import { Controller, useFormContext } from "react-hook-form";
import { Select, SelectItem, SelectProps } from "@heroui/select";

function SelectInput({
    name,
    options,
    onAutosave,
    hideErrorMessage,
    ...props
}: {
    name: string;
    options: { id: string | number; description: string | number; startContent?: React.ReactNode }[];
    onAutosave?: () => void;
    hideErrorMessage?: boolean;
} & Partial<SelectProps>) {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onBlur, onChange, value },
                fieldState: { error, invalid },
            }) => {
                return (
                    <Select
                        onChange={(e) => {
                            if (e.target.value === "") {
                                onChange(null);
                            } else {
                                onChange(e);
                            }
                            if (onAutosave) onAutosave();
                        }}
                        onBlur={onBlur}
                        name={name}
                        isInvalid={invalid}
                        errorMessage={
                            hideErrorMessage ? undefined : error?.message
                        }
                        aria-label="Select"
                        selectedKeys={[value]}
                        showScrollIndicators={false}
                        startContent={
                            options.find((option) => option.id === value)
                                ?.startContent
                        }
                        {...props}
                    >
                        {options.map((option) => (
                            <SelectItem key={option.id} startContent={option.startContent}>
                                {option.description}
                            </SelectItem>
                        ))}
                    </Select>
                );
            }}
        />
    );
}

export default SelectInput;
